import React from 'react';
import axios from 'axios';
import {
  Player,
  PlayerPair,
  EmptyPlayer,
  EmptyPlayerSlot,
  PlayersCount,
  PlayersCountNoNum,
  PlayersInner,
  PlayersList,
  PlayersPairs,
  NoPlayersMessage,
  ActionButton,
  LoginButton,
  NoActionButton,
  GamePlayers,
  KingOfTheHillResults,
  KingOfTheHillPrePlayers,
  MorningOpenPlayers,
  MorningOpenPrePlayers,
  RandomRelationsPlayers,
  RandomRelationsResults,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  TrainingQueue,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining
} from './final.js';

class KingOfTheHillPlayers extends React.Component {
  LABELS = {
    MEN: "Пары мужчин",
    WOMEN: "Пары девушек",
    MIXT: "Пары участников"
  };

  MESSAGES = {
    MEN: "Из мужчин пока никто не подтвердил участие в турнире",
    WOMEN: "Из девушек пока никто не подтвердил участие в турнире",
    MIXT: "Пока никто не подтвердил участие в турнире"
  };

  label = () => {
    if (this.props.game.isMenLimited) return this.LABELS.MEN;
    if (this.props.game.isWomenLimited) return this.LABELS.WOMEN;
    return this.LABELS.MIXT;
  }

  message = () => {
    if (this.props.game.isMenLimited) return this.MESSAGES.MEN;
    if (this.props.game.isWomenLimited) return this.MESSAGES.WOMEN;
    return this.MESSAGES.MIXT;
  }

  players = () => {
    return (
      <PlayersPairs
        label={this.label()}
        message={this.message()}
        players={this.props.game.playersWithPayment}
        totalPlayersNum={this.props.game.totalPlayersWithPaymentNum}
        numberOfPlayers={this.props.game.numberOfPlayers}
        playersCount={true}
        flag={" +1"}
      />
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.players()}
      </React.Fragment>
    )
  }
}

export default KingOfTheHillPlayers;
